<template lang="pug">
.event-list
  .title
    h2 {{ __(eventDay, 'auto') }}{{ timeZoneLabel ? ` (${timeZoneLabel})` : '' }}
  .row-table
    .event-details(v-for="n in (Math.min(events.length, 5) || 3)" :key="n")
      .text-bar.time-bar
      .text-bar.title-bar
      .text-bar.desc-bar
      .text-bar.sponsor-bar
      .text-bar.replay-bar
</template>
<script setup lang="ts">
import { eventNamespace } from '../../js/constants'

withDefaults(defineProps<{
  eventDay?: string
  events?: any[]
  expanded?: boolean
  timeZoneLabel?: string
}>(), {
  eventDay      : '',
  events        : () => [],
  expanded      : true,
  timeZoneLabel : '',
})
</script>
<style lang="scss" scoped>
@keyframes skeleton-loading {
  0% { background-color: $color-gray-x-light; }
  100% { background-color: $color-gray-light; }
}

.text-bar {
  border-radius: $radius-default;
  animation: skeleton-loading 1s linear infinite alternate;
}

// Mirrors EventSchedule.vue's .event-list/.title
.event-list {
  margin-bottom: $size-xxl;

  .title {
    display: flex;
    align-items: center;
    margin-bottom: $size-l;
    border-bottom: 1px $color-gray-light solid;
    padding-bottom: $space-s;

    h2 {
      margin-bottom: 0;
      margin-right: $space-s;
      font-size: $size-l;
    }

    span {
      font-size: $size-xs;
    }
  }
}

// Mirrors EventDetails.vue's .event-details grid
.event-details {
  display: grid;
  border-bottom: 1px solid $color-gray-light;
  margin-bottom: $space-s;
  padding-bottom: $space-s;
  row-gap: $space-xxxs;
  column-gap: $space-s;
  grid-template-columns: 100px 1fr;
  grid-template-areas:
  "time title"
  "sponsor sponsor"
  "desc desc"
  "replay replay";

  @include not-mobile(){
    grid-template-columns: 1.5fr 2fr 1fr 1fr;
    grid-template-areas:
        "time title sponsor replay"
        "time desc sponsor replay";
  }

  .time-bar {
    grid-area: time;
    height: $size-s;
    width: 70px;
  }

  .title-bar {
    grid-area: title;
    height: $size-s;
    width: 60%;
  }

  .desc-bar {
    grid-area: desc;
    height: $size-xs;
    width: 80%;
  }

  .sponsor-bar {
    grid-area: sponsor;
    height: 40px;
    width: 140px;
  }

  .replay-bar {
    grid-area: replay;
    height: 40px; // approximates RogueButton's rendered height
    width: 100%;
    justify-self: end;

    @include not-mobile(){
      max-width: 100px;
    }
  }
}
</style>
